import { getActionTypes } from '../../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('picklistMappingManagement')([
  'SET_LOADER',
  'LOAD_PICKLIST_MAPPINGS',
  'UPSERT_PICKLIST_MAPPING',
  'DELETE_PICKLIST_MAPPING',
  'SET_FORM_LOADER',
]);

export function loadPicklistMapping(picklistMappings) {
  return { type: types.LOAD_PICKLIST_MAPPINGS, picklistMappings };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function setFormLoader(loader) {
  return { type: types.SET_FORM_LOADER, loader };
}

export function upsertPicklistMapping(picklistMapping) {
  return { type: types.UPSERT_PICKLIST_MAPPING, picklistMapping };
}

export function deletePicklistMapping(picklistMapping) {
  return { type: types.DELETE_PICKLIST_MAPPING, picklistMappingId: picklistMapping.id };
}

export default function picklistMappingReducer(
  state = { isPicklistMappingPageLoading: true, picklistMappings: [], isPicklistMappingFormLoading: false },
  action
) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isPicklistMappingPageLoading: action.loader };
    }
    case types.SET_FORM_LOADER: {
      return { ...state, isPicklistMappingFormLoading: action.loader };
    }
    case types.LOAD_PICKLIST_MAPPINGS: {
      return { ...state, picklistMappings: action.picklistMappings };
    }
    case types.DELETE_PICKLIST_MAPPING: {
      return {
        ...state,
        picklistMappings: state.picklistMappings.filter(
          ({ id: picklistMappingId }) => picklistMappingId !== action.picklistMappingId
        ),
      };
    }
    case types.UPSERT_PICKLIST_MAPPING: {
      const { picklistMapping } = action;
      return {
        ...state,
        picklistMappings: [
          ...state.picklistMappings.filter(({ id: picklistMappingId }) => picklistMappingId !== picklistMapping.id),
          picklistMapping,
        ],
      };
    }
    default:
      return state;
  }
}

export const allPicklistMappingsSelector = (state) => state.picklistMappingReducer.picklistMappings;
export const isPicklistMappingPageLoadingSelector = (state) =>
  state.picklistMappingReducer.isPicklistMappingPageLoading;
export const isPicklistMappingFormLoadingSelector = (state) =>
  state.picklistMappingReducer.isPicklistMappingFormLoading;
